import { render, staticRenderFns } from "./checklist-item.vue?vue&type=template&id=0b6a1440&scoped=true"
import script from "./checklist-item.vue?vue&type=script&lang=js"
export * from "./checklist-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a1440",
  null
  
)

export default component.exports